
import './header.css'
import CTA from './CTA'
import HeaderSocial from './HeaderSocial'
import Typewriter from "typewriter-effect";
import Circle from './Circle'
import { motion } from 'framer-motion'
import BottomHeader from './BottomHeader'

function Header() {
  return (
    <header id="header" >
      <motion.div className="container header_container"
      initial={{
        opacity :0
      }}
      animate={{
        opacity:1
      }}
      transition={{
        duration:1.5,
        ease: "easeIn"
      }}>
      <h5>Hello I'm</h5>
      <h1>Dhanush</h1>
            <Typewriter options={{
              autoStart:true,
              loop:true,
              delay:40,
              skipAddStyles:false,
              wrapperClassName:'type',
              strings:[
                "Full Stack Developer",
                "UI/UX Designer",
              ],
            }} />
      <CTA />
      <Circle />
      <HeaderSocial />
      <motion.a href="#contact" className='scroll_down'
      initial={{
        opacity :0
      }}
      animate={{
        opacity:1
      }}
      transition={{ delay: 2, duration: 1,ease:'easeIn' }}>Scroll Down</motion.a>
      </motion.div>
      <BottomHeader />
    </header>
  )
}

export default Header